import { render, staticRenderFns } from "./QuestionsSubPageBase.vue?vue&type=template&id=566a065b&"
import script from "./QuestionsSubPageBase.vue?vue&type=script&lang=ts&"
export * from "./QuestionsSubPageBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
